function Like({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
    >
      <path
        d="M17.7308 20.8187H7.2115V8.81866L13.8462 2.22266L14.6923 3.06866C14.7961 3.17249 14.8823 3.30999 14.951 3.48116C15.0195 3.65232 15.0538 3.81357 15.0538 3.96491V4.21866L13.9923 8.81866H20.6923C21.1679 8.81866 21.5881 9.00107 21.9527 9.36591C22.3176 9.73057 22.5 10.1507 22.5 10.6264V12.2417C22.5 12.3455 22.4865 12.4577 22.4595 12.5782C22.4327 12.6987 22.4026 12.8109 22.3693 12.9149L19.5038 19.6764C19.3603 19.9969 19.1199 20.2674 18.7828 20.4879C18.4456 20.7084 18.0949 20.8187 17.7308 20.8187ZM8.7115 19.3187H17.7308C17.8013 19.3187 17.8733 19.2994 17.947 19.2609C18.0208 19.2224 18.077 19.1583 18.1155 19.0687L21 12.3187V10.6264C21 10.5366 20.9712 10.4628 20.9135 10.4052C20.8558 10.3475 20.7821 10.3187 20.6923 10.3187H12.0963L13.35 4.83791L8.7115 9.45716V19.3187ZM7.2115 8.81866V10.3187H4V19.3187H7.2115V20.8187H2.5V8.81866H7.2115Z"
        fill="#004A68"
      />
    </svg>
  );
}

export default Like;
